<template>

 <!-- Step 1: Input phone number -->
  <div>
    <b-alert
      v-if="tooManyRequest"
      variant="default"
      show
      class="border border-primary bg-light justify-content-center"
    >
      {{ $t("check-in-form.error-system-locked-new-first") }}
      <template v-if="lockHours != 0">
        {{ $t("check-in-form.error-system-locked-new-hours").replace('X', lockHours) }}
        {{ $t("check-in-form.error-system-locked-new-middle") }}
      </template>
      {{ $t("check-in-form.error-system-locked-new-minutes").replace('Y', lockMinutes) }}
      {{ $t("check-in-form.error-system-locked-new-last") }}
    </b-alert>
    <template v-if="checkedConfirmLock != false && !tooManyRequest">
      <b-alert
        variant="default"
        show
        class="border border-primary bg-light justify-content-center"
      >
        <div v-if="isRequired" class="login-instruction text-left">
          <p class="mb-2">{{ $t("check-in-form.instruction-login-intro") }}</p>
          <p class="mb-2">{{ $t("check-in-form.instruction-login-auth") }}</p>
          <p class="login-instruction-heading mb-1">{{ $t("check-in-form.instruction-login-notes-heading") }}</p>
          <p class="mb-1">{{ $t("check-in-form.instruction-login-note-mail") }}</p>
          <p class="mb-0">{{ $t("check-in-form.instruction-login-note-flag") }}</p>
        </div>
        <div v-else class="login-instruction text-left">
          <p class="mb-2">{{ $t("check-in-form.instruction-login-intro") }}</p>
          <p class="mb-0">{{ $t("check-in-form.instruction-flag-notice") }}</p>
        </div>

      </b-alert>
        <form @submit.prevent="goNext">
          <phone-field
            :label="$t('check-in-form.word-phone')"
            :value="phoneNumber"
            @input="updatePhoneNumber"
            :error="phoneError"
            required
          />
          <p v-if="isRequired">
            <text-field
              :label="$t(`check-in-form.word-vericode`)"
              v-model="veriCode"
              :error="phoneError"
            />
          </p>
          <div class="d-flex justify-content-center mb-2">
            <button type="submit" class="btn btn-primary">
              {{ $t("check-in-form.terms-accept") }}
            </button>
          </div>
          <div>
            <p
              v-if="errorCode != ''"
              class="form-message m-4 text-center text-danger pre-wrap"
              >{{
                $t("check-in-form.error-confirm-booking") + `(Error: ${errorCode})`
                +
                "\n" + this.$t("check-in-form.error-confirm-booking-number-of-attempts").replace('XXX', lockCountDown)
              }}
            </p>
          </div>
      </form>
    </template>

    <div class="d-flex justify-content-center mb-2">
      <a :href="`/terms-and-condition?lang=${$i18n.locale}`" target="_blank">
        <small>{{ $t("check-in-form.terms-link-text") }}</small>
      </a>
    </div>
  </div>

</template>

<script>
import bookingsAPI from "@/api/bookings";
import PhoneField from "@/components/form-fields/PhoneField";
import TextField from "@/components/form-fields/TextField";
import { mapActions, mapState } from "vuex";

export default {
  async mounted() {
    // Ensure previous step got processed.
    if (!this.facility.id) this.$router.replace({ path: "/error-404" });
    await this.init();
  },
  components: { PhoneField, TextField},
  computed: {
    ...mapState("checkin", [
      "countryCode", "phoneNumber", "facility", "token",
    ]),
    isRequired() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.has('vericode');
    }
  },
  data() {
    return {
      phoneError: "",
      termsAndConditions: "",
      tooManyRequest: false,
      lockHours: 0,
      lockMinutes: 0,
      lockCountDown: null,
      checkedConfirmLock: false,
      errorCode: "",
      error_msg: "",
      veriCode: "",
      queryParameters: "",

    };
  },

  methods: {
    async init() {
      $store.commit("checkin/set_loading", true);

      try {
        await bookingsAPI.checkConfirmLock(this.token);
        this.checkedConfirmLock = true;
      } catch (e) {
        console.log(e);
        const status = e.response.status;
        if (status === 429) {
          this.tooManyRequest = true;
          this.lockHours = e.response.data.data.hours;
          this.lockMinutes = e.response.data.data.minutes;
          $store.commit("checkin/set_loading", false);
          console.log('loading done');
          return;
        }
      }

      $store.commit("checkin/set_loading", false);
      console.log('loading done');
    },
    updatePhoneNumber(num, obj) {
      const { country, number } = obj || {};
      // 国旗だけ変えた（電話番号未入力）場合でも国番号更新
      if (country?.dialCode && (!number || !number.significant)) {
        this.updatePhone({ code: country.dialCode, number: number.significant || "" });
        this.phoneError = "";
        return;
      }
      if (!country || !number) return;
      this.updatePhone({ code: country.dialCode, number: number.significant });
      this.phoneError = "";
    },
    async goNext() {
      // Ensure valid phone number length

      if(this.isRequired){
        if (this.phoneNumber.length < 5 && this.veriCode === "") {
          this.phoneError = this.$t("check-in-form.error-field-phone-vericode");
          return;
        }
      }else{
        if (this.phoneNumber.length < 5) {
          this.phoneError = this.$t("check-in-form.error-field-required");
          return;
        }
      }

      // Fetch booking record
      this.errorCode = '';
      this.lockCountDown = '';

      if (this.isRequired) {
        this.queryParameters = 'on'; // vericodeがある場合
      } else {
        this.queryParameters = null; // vericodeがない場合
      }

      try {
        var response = await bookingsAPI.checkPhone(
          {
            code: this.countryCode,
            number: this.phoneNumber,
            verificationCode: this.veriCode,
          },
          {
            token: this.token,
            facility_id: this.facility.id,
            query: this.queryParameters,
          },
        );


      } catch (e) {
        const status = e.response.status;
        this.errorCode = e.response.data.data.errorCode;
        this.lockCountDown = e.response.data.data.lockCountDown;
        if (status === 422) {
          this.phoneError = this.$t("check-in-form.error-phone-notfound");
          return;
        }
        if (status === 429) {
          this.tooManyRequest = true;
          this.lockHours = e.response.data.data.hours;
          this.lockMinutes = e.response.data.data.minutes;
          return;
        }
        this.$toast.error(this.$t("check-in-form.error-generic"), {
          position: "top"
        });
        return;
      }
      // Validate that record exist
      const data = response.data;
      if (data.length < 1) {
        this.phoneError = this.$t("check-in-form.error-phone-notfound");
        return;
      }
      // Save booking record & proceed to next step.

      this.updateBookingData(data[0]);

// isRequired の結果に基づいて適切なルートに遷移する
     if (this.isRequired) {
        this.$router.replace({ name: "checkin-step-2" , query: { vericode: 'on' }});
     } else {
        this.$router.replace({ name: "checkin-step-2" });
      }
    },

    ...mapActions("checkin", ["updateBookingData", "updatePhone"])
  }
};
</script>

<style scoped>
.login-instruction {
  line-height: 1.7;
}
.login-instruction-heading {
  font-weight: 600;
}
</style>
